/* global angular */

angular.module('gc.fallback-avatar', [])
.directive('fallbackSrc', function () {
  'use strict';
  var fallbackUrl = '/front/images/avatar_3.png';
  return {
    restrict: "A",
    link: function postLink(scope, el, attrs) {
      if (!attrs.ngSrc && !attrs.src) {
        el.attr('src', fallbackUrl);
      }

      el.unbind('error');
      el.bind('error', function() {
        angular.element(this).attr('src', fallbackUrl);
      });
    }
  };
});
